import { useCallback, useEffect, useState } from 'react'
import { Spinner } from 'components'
import { useTranslation } from 'react-i18next'
import { listSettings, updateSetting } from 'service/AdminPanelService'
import styles from '../AdminFullPage.module.scss'

function SettingsTab({ notify }) {
  const { t } = useTranslation('common')
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [drafts, setDrafts] = useState({})

  const load = useCallback(() => {
    setLoading(true)
    listSettings()
      .then((res) => {
        const data = res?.data || res
        setItems(Array.isArray(data) ? data : data?.results || [])
      })
      .catch(() => setItems([]))
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    load()
  }, [load])

  const onSave = (id) => {
    const value = drafts[id]
    if (value === undefined) return
    updateSetting(id, { value })
      .then(() => {
        notify(t('admin.fullPage.settings_saved'), 'success')
        setDrafts((d) => {
          const copy = { ...d }
          delete copy[id]
          return copy
        })
        load()
      })
      .catch(() => notify(t('common.error_saving'), 'error'))
  }

  return (
    <div>
      <h2 className={styles.section_title}>{t('admin.fullPage.settings_title')}</h2>

      {loading ? (
        <div className={styles.spinner_box}>
          <Spinner.Center />
        </div>
      ) : items.length === 0 ? (
        <div className="unv-empty">{t('admin.fullPage.settings_empty')}</div>
      ) : (
        <table className="unv-table">
          <thead>
            <tr>
              <th>{t('admin.fullPage.settings_th_key')}</th>
              <th>{t('admin.fullPage.roles_th_description')}</th>
              <th>{t('admin.fullPage.settings_th_value')}</th>
              <th style={{ width: 120 }}>{t('common.action')}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((s) => {
              const draftValue =
                drafts[s.id] !== undefined ? drafts[s.id] : s.value ?? ''
              const dirty = drafts[s.id] !== undefined
              return (
                <tr key={s.id}>
                  <td>
                    <strong>{s.key || s.code}</strong>
                  </td>
                  <td>{s.description || s.title || '—'}</td>
                  <td>
                    <input
                      className="unv-input"
                      value={draftValue}
                      onChange={(e) =>
                        setDrafts((d) => ({ ...d, [s.id]: e.target.value }))
                      }
                    />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="unv-btn unv-btn--sm"
                      disabled={!dirty}
                      onClick={() => onSave(s.id)}
                    >
                      {t('common.save')}
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default SettingsTab
